import {DataGridPro} from '@mui/x-data-grid-pro'
import ExcelDownLoadModal from 'pages/common/ExcelDownloadModal'
import {customerMinimumFlowColumns} from 'pages/customer/dataConfig/declearColumns'
import {customerMinimumFlowFilter} from 'pages/customer/dataConfig/declearFilters'
import {customerMinimumFlowRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {getMinimumFlowList} from 'utils/apiCalling/api'
import CustomPagination from 'utils/designSytem/CustomPagination'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {scrollTop} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'

const CustomerMinimumFlow = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const officeInfo = useSelector((state: any) => state.officeInfo)
  const cooperInfo = useSelector((state: any) => state.cooperInfo)
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [minimumList, setMinimumList] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<any>(null)
  const [filter, setFilter] = useState<any>(customerMinimumFlowFilter)
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  const [downloadOpen, setDownloadOpen] = useState<boolean>(false)
  const [shouldCallApi, setShouldCallApi] = useState<boolean>(false)
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const getMinimumFlowListCall = () => {
    const checkBusan = String(officeInfo.value).slice(0, 2) === '13'
    const hasAnyTrue = Object.values(filter.searchOption).some((v) => v === true)
    const newSearchOption =
      !filter.searchOption.customerNumber && hasAnyTrue
        ? {installer: false}
        : {customerNumber: true}
    let selectedFilter = filter
    if (checkBusan) {
      selectedFilter = {
        ...filter,
        searchOption: newSearchOption,
      }
    }
    getMinimumFlowList(officeInfo, cooperInfo, selectedFilter, {
      success: (res: any) => {
        setMinimumList(res)
      },
      count: (count: any) => {
        setTotalCount(count)
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }
  const busanSearchHandler = (officeId: any) => {
    return ['customerNumber', 'customerName', 'address', 'managerName']
  }

  const columns: any = customerMinimumFlowColumns(filter)
  const rows = customerMinimumFlowRows(minimumList)

  const searchHandler = () => {
    setFilter((prev: any) => ({...prev, page: 1}))
    setShouldCallApi(true)
  }

  useEffect(() => {
    if (shouldCallApi) {
      getMinimumFlowListCall()
      setShouldCallApi(false)
    }
  }, [filter, shouldCallApi])

  useEffect(() => {
    scrollTop()
    getMinimumFlowListCall()
  }, [
    filter.date,
    filter.start,
    filter.end,
    officeInfo,
    cooperInfo,
    filter.flag,
    filter.page,
    filter.rowPerPage,
  ])
  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerMinimumFlow.description}
        tooltipText={toolTipText.customerMinimumFlow.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'customer-minimumFlow'}
        setFilter={setFilter}
        searchCallback={searchHandler}
        total={totalCount}
        control={['useSwitch', 'selectDate', 'timeRange']}
        actions={['download']}
        searchOptions={busanSearchHandler(officeInfo.value)}
        checkData={null}
        onDelete={null}
        onCancel={null}
        setTypeName={null}
        onDownloadOpen={() => setDownloadOpen(true)}
      >
        <DataGridPro
          rows={rows}
          rowCount={rows?.length}
          columns={columns}
          rowHeight={220}
          disableColumnMenu
          paginationMode={'server'}
          hideFooterPagination={true}
          pagination={true}
          hideFooter={true}
          loading={loading}
          autoHeight={true}
        />
        <CustomPagination filter={filter} setFilter={setFilter} totalCount={totalCount} />
      </MeterariumPageLayout>
      <ExcelDownLoadModal
        type={'최소유량 조회'}
        search={filter}
        open={downloadOpen}
        onClose={() => setDownloadOpen(false)}
      />
    </>
  )
}
export default CustomerMinimumFlow
